import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { GstFormComponent } from './gst-form/gst-form.component';
import { GstListComponent } from './gst-list/gst-list.component';
import { GstRoutingModule } from './gst-routing.module';

@NgModule({
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule,
    AngularMaterialModule,SharedModule,
    MatFormFieldModule,
    MatInputModule,
    NgxMatSelectSearchModule,
    GstRoutingModule
  ],
  declarations: [GstFormComponent, GstListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GSTModule { }
